import { RadarSeriesChart } from '@euler/lib/charts/RadarSeriesChart';
import { formatBiAxisTick, formatBiShortLabel } from '@euler/model/bi/format';
import { memo, useMemo } from 'react';
import { BiChartModel } from '../functions/biChartModel';
import { BiVizLook } from '../functions/biVizLook';
import { useBiChartTheme } from './useBiChartTheme';

type Radar = Extract<BiChartModel, { kind: 'radar' }>;

/** A radar: one polygon per series, filled as styled. */
export const BiRadarChart = memo(
  ({
    model,
    look,
    width,
    height,
  }: {
    model: Radar;
    look: BiVizLook;
    width: number;
    height: number;
  }) => {
    const theme = useBiChartTheme();
    const short = !model.perSeries && model.units.left !== null;
    const series = useMemo(
      () =>
        model.series.map(entry => ({
          key: entry.key,
          color: entry.color,
          values: entry.values,
          // Points sit close on a web: short labels where one unit is
          // captioned above; in full where each series has its own.
          labels: short
            ? entry.values.map(value =>
                value === undefined ? undefined : formatBiShortLabel(value),
              )
            : entry.labels,
        })),
      [model.series, short],
    );
    return (
      <RadarSeriesChart
        width={width}
        height={height}
        spokes={model.categories}
        series={series}
        perSeries={model.perSeries}
        fillOpacity={look.radar.fillOpacity}
        dataLabels={look.dataLabels}
        format={formatBiAxisTick}
        theme={theme}
      />
    );
  },
);
